const TourHelpButton = ({ onClick, isRunning = false }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={isRunning}
    data-tour="tour-help"
    aria-label="Start guided tour"
    title="Replay the guided tour"
    className="px-3 py-2 bg-indigo-500/20 hover:bg-indigo-500/30 text-indigo-100 rounded-lg transition-colors text-sm border border-indigo-300/30 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
  >
    <span aria-hidden="true">?</span>{" "}
    <span className="hidden sm:inline">Guided tour</span>
  </button>
);

export default TourHelpButton;
